import axios from '../lib/axios'
import { buildUrlString } from '@!/Util'

export const getNewBooksApi = async (safeSearch, genreTabName, page, perPage) => {
  const url = buildUrlString(`/api/v1/new_books`, { safe_search: safeSearch, genre_tab_name: genreTabName, page: page, per_page: perPage })
  return await axios.get(url)
}

export const getTopNewBooksApi = async (safeSearch, genreTabName) => {
  const params = {
    safe_search: safeSearch,
  }

  if (genreTabName) {
    params.genre_tab_name = genreTabName
  }

  const url = buildUrlString('/api/v1/new_books/top', params)

  return await axios.get(url)
}
